<template>
<div class="header-box">
    <div class="title-box mainWidth">
        <div class="title">{{name}}</div>
        <div class="search-box">
            <el-input class="search-input" placeholder="请输入直播项目名称或编号" v-model="keyword" size="medium" prefix-icon="el-icon-search" @keyup.enter.native="onSearchBtn" @change='changeKeyword'>
            </el-input>
            <el-button class="search-btn" size="medium" @click="onSearchBtn">搜索</el-button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            keyword: ''
        }
    },
    computed: {
        name() {
            return this.title ? this.title + '开标直播网' : ''
        }
    },

    methods: {
        onSearchBtn() {
            this.$store.commit('app/SET_ISSEARCH',true)
            if (this.$route.name !== 'SearchPage') {
                this.$router.push({
                    name: 'SearchPage',
                })
            }
        },
        changeKeyword(){
            this.$store.commit('app/SET_KEYWORDSEARCH',this.keyword)
        }
    },
    created() {
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword
        }
    },
}
</script>

<style lang="scss" scoped>
.header-box {
    height: 200px;
    min-width: 900px;
    // opacity: 0.47;
    background-image: url('../../static/images/bg-header.jpg');
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-top: 34px;

    .title-box {
        height: 166px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            height: 166px;
            line-height: 162px;
            font-size: 32px;
            font-weight: 600;
            color: #FFFFFF;
        }

        .search-box {
            display: flex;
        }

    }
}

/deep/ {
    .el-input.search-input {
        // width: 386px;
        width: 278px;

        .el-input__inner {
            border-radius: 4px 0 0 4px;
        }
    }

    .search-btn.el-button {
        width: 108px;
        background-color: #6790ff;
        border-radius: 0 4px 4px 0;
        border: 0;
        color: #fff;
        font-size: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeaderBox.vue